export default __webpack_public_path__ + "0c6e90d53b386ec55a6001fae63deea1.png";